import { createRoute } from "infrastructure/routing";
import React, { FC } from "react";
import { Switch } from "react-router";
import { routes } from "routes/routes";
import { ErrorTest } from "routes/test/ErrorTest";

export const TestRouteIndex: FC = () => <Switch>
    {createRoute(routes.test.error, { component: ErrorTest })}
</Switch>;
